<template>
  <div>
    <v-alert v-if="isAdmin" prominent type="warning" icon="mdi-source-repository-multiple">
      <v-row align="center">
        <v-col class="grow">{{ $t("forms.info.warningDirectEdit") }}</v-col>
        <v-col class="shrink">
          <v-btn to="/manage/edit/softwares">
            <v-icon left>mdi-arrow-right-circle</v-icon>
            {{ $t("forms.info.gotoDirectEdit") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <PendingUserForms
      v-if="pendingForms.length"
      :title="$t('table.pendingForms')"
      :items="pendingForms"
    />

    <v-card class="mt-4">
      <v-card-title>{{ $t("forms.title") }}</v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item to="/my-forms/software/newSoftware">
            <v-list-item-icon><v-icon>mdi-plus</v-icon></v-list-item-icon>
            {{ $t("software.forms.newSoftware") }}
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="softwares"
      :search="search"
      :loading="loading"
      :loading-text="$t('table.loading')"
      :items-per-page="30"
      :footer-props="{
        itemsPerPageOptions: [15, 30, -1],
        itemsPerPageText: $t('table.itemsPerPageText')
      }"
      class="elevation-1 table-cursor-hand mt-4"
      sort-by="launched_date"
      sort-desc
      @click:row="openSoftware"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
          />
        </v-toolbar>
      </template>
      <template v-slot:item.researchers="{ item }">
        {{ researcherNames(item.researchers) }}
      </template>
      <template v-slot:item.software_type="{ item }">
        {{ $t(`form.software_types.${item.software_type || 'other'}`) }}
      </template>
      <template v-slot:item.status="{ item }">
        {{ $t(`form.software_statuses.${item.status || 'active'}`) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from "axios";
import PendingUserForms from "@/components/forms/PendingUserForms";

export default {
  name: "ListSoftware",
  components: { PendingUserForms },
  data: () => ({
    loading: true,
    search: "",
    softwares: [],
    people: [],
    pendingForms: []
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("table.name"), value: "name" },
        { text: this.$t("form.software_type"), value: "software_type" },
        { text: this.$t("form.software_status"), value: "status" },
        { text: this.$t("form.software_current_version"), value: "current_version" },
        { text: this.$t("table.researchers"), value: "researchers" },
        { text: this.$t("table.launched_date"), value: "launched_date" }
      ];
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      const endpoint = this.$store.state.endpoint;
      try {
        const [softwareResponse, peopleResponse, formsResponse] = await Promise.all([
          axios.get(`${endpoint}/user/software`),
          axios.get(`${endpoint}/personName`),
          axios.get(`${endpoint}/user/moderatedOperations/pending/software`)
        ]);
        this.softwares = softwareResponse.data;
        this.people = peopleResponse.data;
        this.pendingForms = formsResponse.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    researcherNames(ids) {
      return (ids || []).map(id => {
        const person = this.people.find(item => String(item.id) === String(id));
        if (!person || !person.preferred_name) {
          return "";
        }
        return `${person.preferred_name.given_name} ${person.preferred_name.family_name}`.trim();
      }).filter(Boolean).join(", ");
    },
    openSoftware(item) {
      this.$router.push(`/softwares/${item.id}`);
    }
  }
};
</script>
